import styled from 'styled-components'

export const Logo = styled.img`
  width: 30%;
  display: flex;
  height: auto;
  margin: 1em auto 2em;
`
